import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M3_Summary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Module 3 Summary"
    videos={[]} // No videos for the summary
    takeaways={[
      {
        text: "Learn the theory part of dynamic memory allocation with examples and proper syntax.",
      },
      {
        text: "Practice coding problems related to pointers, and also practice questions where they ask the output of the code and pointer arithmetic. (Although they don’t ask pointer arithmetic directly, some part of the code contains pointer arithmetic, and you may be asked the output.)",
      },
      {
        text: "Again, if you think you can’t deal with coding questions, at least learn the basic syntax or basic code structures for every example. (Even if you don't write the exact code, if you write the correct syntax, some teachers may give marks if they want to make you pass).",
      },
      {
        text: "In the exams, write the expected output after code at last (even though your code logic is wrong, write the expected output as per question). (If you do this, your chance of getting more marks will be increased).",
      },
    ]}
    questions={[]} // No specific questions for the summary
    exampleVideos={[]} // No example videos for the summary
  />
);
}

export default OOPS_M3_Summary;
